{
    "Profile_Drivers_Claim.claim": "Claim",
    "Profile_Drivers_Claim.claimDetails": "Claim Details",
    "Profile_Drivers_Claim.dateOfClaim": "Date of Claim",
    "Profile_Drivers_Claim.claimReason": "Claim Reason",
    "Profile_Drivers_Claim.lossAmount": "Loss Amount",
    "Profile_Drivers_Claim.atFault": "At Fault?"
}
